import { memo } from 'react'

import { SkeletonLoader } from '@/shared/lib/components/SkeletonLoader/SkeletonLoader'

/**
 * Компонент скелетона для состояния загрузки BonusesPanel
 */
export const BonusPanelSkeleton = memo(() => {
	return (
		<>
			<SkeletonLoader width={220} height={20} borderRadius={8} />
			<SkeletonLoader width={270} height={40} borderRadius={8} />
		</>
	)
})
